export default __webpack_public_path__ + "static/media/big-komin.ed7fce01.jpg";